const driverLicenseControlMethods = {
    DIRECT: 'DIRECT',
    DISTANCE: 'DISTANCE',
};

export default driverLicenseControlMethods;
